import { useMutation } from "react-query";
import { axiosPost } from "../../lib/axiosClient";

const useUpdateWorksheet = () => {
  return useMutation((test) => {
    return axiosPost("/api/cw/updateWorkSheet", test);
  });
};
export default useUpdateWorksheet;
